'use client'

import useTranslation from 'next-translate/useTranslation'

function FooterSocialLinks() {
  const { t, lang } = useTranslation()
  return (
    <div className="inline-flex w-full justify-center pt-2 sm:justify-end">
      <a
        className="mx-4 ml-3 flex flex-col items-center text-white"
        href="https://wa.me/34931228535?text=Hola,%20me%20gustaría%20recibir%20más%20información%20de%20Vermut.%20Gracias."
        target="_blank"
        rel="noreferrer"
        onClick={() => {
          // @ts-expect-error google analytics global variable
          dataLayer.push({ event: 'WhatsApp' })
        }}>
        <svg
          className="h-5 w-5"
          width="29"
          height="30"
          viewBox="0 0 29 30"
          fill="none"
          xmlns="http://www.w3.org/2000/svg">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M24.7746 4.36027C23.437 2.97402 21.8454 1.87482 20.0922 1.12637C18.339 0.377915 16.459 -0.00491868 14.5611 4.77077e-05C6.60259 4.77077e-05 0.123849 6.66873 0.120632 14.8659C0.120632 17.4857 0.784912 20.0425 2.04753 22.298L0 30L7.6545 27.9317C9.77183 29.1183 12.1439 29.7406 14.5547 29.7417H14.5611C22.518 29.7417 28.9967 23.073 28.9999 14.8758C29.0054 12.9226 28.6348 10.9875 27.9096 9.18262C27.1843 7.3777 26.1188 5.73868 24.7746 4.36027ZM14.5611 27.2328H14.5563C12.4066 27.2331 10.2966 26.6376 8.44746 25.5089L8.00997 25.2407L3.46777 26.4678L4.67891 21.9088L4.39422 21.4418C3.19239 19.4719 2.55617 17.1922 2.55901 14.8659C2.56222 8.05314 7.94563 2.51053 14.5659 2.51053C16.1426 2.50692 17.7043 2.82531 19.1606 3.44725C20.617 4.06919 21.9391 4.98234 23.0504 6.13384C24.1676 7.27986 25.0532 8.6425 25.6558 10.143C26.2585 11.6435 26.5664 13.2521 26.5616 14.8758C26.5583 21.6886 21.1749 27.2328 14.5611 27.2328ZM21.1444 17.9775C20.7825 17.7904 19.01 16.8928 18.6787 16.7686C18.3489 16.6444 18.1093 16.5832 17.868 16.9541C17.6268 17.325 16.9351 18.1613 16.7244 18.4097C16.5137 18.6581 16.303 18.6879 15.9427 18.5024C15.5824 18.317 14.4195 17.9245 13.0411 16.6593C11.9683 15.674 11.2445 14.4585 11.0338 14.0859C10.8231 13.7133 11.0113 13.5129 11.193 13.3275C11.3555 13.1619 11.5533 12.8936 11.7335 12.6767C11.9136 12.4597 11.9731 12.3057 12.0938 12.0573C12.2144 11.8089 12.1549 11.592 12.0632 11.4065C11.9731 11.2194 11.2509 9.39118 10.9502 8.64764C10.659 7.92728 10.3615 8.02333 10.1395 8.01339C9.90964 8.00371 9.67958 7.9993 9.44951 8.00014C9.26656 8.00494 9.08655 8.04861 8.92076 8.1284C8.75497 8.20819 8.60697 8.32238 8.48606 8.46382C8.15473 8.83642 7.22345 9.73397 7.22345 11.5622C7.22345 13.3904 8.51662 15.1573 8.69676 15.4057C8.87691 15.6541 11.2413 19.405 14.8603 21.0146C15.7224 21.3971 16.3947 21.6256 16.9174 21.7979C17.7812 22.081 18.5677 22.0396 19.1901 21.9453C19.8834 21.8393 21.3245 21.0477 21.6253 20.18C21.9261 19.3122 21.9261 18.5687 21.836 18.413C21.7459 18.2574 21.5031 18.163 21.1444 17.9775Z"
            fill="white"
          />
        </svg>
        <span className="text-xs">Whatsapp</span>
      </a>
      <a
        className="mx-4 flex flex-col items-center text-white"
        href="https://www.facebook.com/Vermutapp1"
        target="_blank"
        rel="noreferrer">
        <svg
          className="h-5 w-5"
          width="30"
          height="29"
          viewBox="0 0 30 29"
          fill="none"
          xmlns="http://www.w3.org/2000/svg">
          <path
            d="M30 14.5888C30 6.53143 23.2846 0 15.0019 0C6.71541 0.00181227 0 6.53144 0 14.5906C0 21.8705 5.48556 27.9054 12.6547 29V18.806H8.84889V14.5906H12.6584V11.3738C12.6584 7.71847 14.8988 5.6996 18.324 5.6996C19.9663 5.6996 21.6817 5.98413 21.6817 5.98413V9.57243H19.79C17.9284 9.57243 17.3472 10.6979 17.3472 11.8523V14.5888H21.5054L20.8418 18.8042H17.3453V28.9982C24.5144 27.9036 30 21.8687 30 14.5888Z"
            fill="white"
          />
        </svg>
        <span className="text-xs">Facebook</span>
      </a>
      <a
        className="mx-4 ml-3 flex flex-col items-center text-white"
        href={`https://www.instagram.com/vermutapp/?hl=${lang}`}
        target="_blank"
        rel="noreferrer">
        <svg
          fill="none"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
          className="h-5 w-5"
          viewBox="0 0 24 24">
          <rect width="20" height="20" x="2" y="2" rx="5" ry="5"></rect>
          <path d="M16 11.37A4 4 0 1112.63 8 4 4 0 0116 11.37zm1.5-4.87h.01"></path>
        </svg>
        <span className="text-xs">Instagram</span>
      </a>
      <a
        className="mx-4 ml-3 flex flex-col items-center text-white"
        href="https://www.youtube.com/channel/UC5OqqA4qGtkG8GF-1V6OtMg"
        target="_blank"
        rel="noreferrer">
        <svg
          className="h-5 w-5"
          width="29"
          height="23"
          viewBox="0 0 29 23"
          fill="none"
          xmlns="http://www.w3.org/2000/svg">
          <path
            d="M14.5 0C0.2494 0 0 1.30532 0 11.5C0 21.6947 0.2494 23 14.5 23C28.7506 23 29 21.6947 29 11.5C29 1.30532 28.7506 0 14.5 0ZM19.1473 11.9988L12.6368 15.1292C12.0669 15.401 11.6 15.0964 11.6 14.4482V8.55182C11.6 7.90513 12.0669 7.59896 12.6368 7.87078L19.1473 11.0012C19.7171 11.276 19.7171 11.724 19.1473 11.9988Z"
            fill="white"
          />
        </svg>
        <span className="text-xs">Youtube</span>
      </a>
    </div>
  )
}

export default FooterSocialLinks
